import { AppButton } from 'components';
import ChapterSearch from 'components/molecules/ChapterSearch';
import CoursesSearch from 'components/molecules/CoursesSearch';
import LessonsSearch from 'components/molecules/LessonsSearch';
import {
  AppModal,
  AppModalBody,
  // AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useBulkAssignInChapter from 'hooks/API/POST/useBulkAssignInChapter';
// import useToaster from 'hooks/useToaster';
import { memo, useEffect, useState } from 'react';
import * as AppPics from 'assets/images';
import UserSelect from 'components/molecules/UserSelect';
import { ROLES } from 'utilities/constants';
import { MdSwapCalls } from 'react-icons/md';
import { UserContext } from 'context/UserContext';
import ReviewContent from 'pages/manage-topics/manage-contents/Tabs/ReviewContent';

function BulkAssignChapter({ open, closeModal, data = {} }) {
  const { apiData, userPermissions } = data;
  const { classID, chapterID, courseID } = apiData;
  useEffect(() => {}, []);
  function clearArray() {
    setAssignedSe('');
    setAssignedTutor('');
  }

  const bulkAssigner = useBulkAssignInChapter({ classID });

  const handleClose = () => {
    clearArray();
    closeModal();
  };

  const [assignedSe, setAssignedSe] = useState();
  const [assignedSeOwner, setAssignedSeOwner] = useState();
  const [assignedTutor, setAssignedTutor] = useState();
  const [assignedStatus, setAssignedStatus] = useState();

  return (
    <AppModal
      open={open}
      closeModal={closeModal}
      size="lg"
      // popUpProps={{ className: '__appModalMinHeight' }}
    >
      <AppModalHeader>Bulk Assign</AppModalHeader>
      <AppModalBody classNames="p-4">
        <div className="row mb-4">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor={'seSelect'}>Pick a Subject expert (Content Maintainer)</label>
            <UserSelect
              dependencies={{ query: { roles: [ROLES.SUBJECT_EXPERT] } }}
              handleChange={setAssignedSe}
              values={assignedSe}
              isMulti={false}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor={'seOwner'}>Pick a Subject expert (Content Owner)</label>
            <UserSelect
              dependencies={{ query: { roles: [ROLES.SUBJECT_EXPERT] } }}
              handleChange={setAssignedSeOwner}
              values={assignedSeOwner}
              isMulti={false}
            />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor={'SeTutor'}>Pick a Teacher</label>
            <UserSelect
              dependencies={{ query: { roles: [ROLES.TUTOR] } }}
              handleChange={setAssignedTutor}
              values={assignedTutor}
              isMulti={false}
            />
          </div>
          <div className="col-6">
            <ReviewContent
              area={userPermissions?.chapter.canBulkAssign}
              value={assignedStatus}
              onChange={(value) => setAssignedStatus(value)}
              disableList={[]}
              selectProps={{ disabled: false }}
              reviewOptions={userPermissions?.chapter?.bulkAssignOptions}
            />
          </div>
        </div>
        <div className="d-flex flex-row mt-4 justify-content-center">
          <>
            <AppButton
              variantClass="btn-primary mx-3 d-flex align-items-center"
              style={{ minWidth: '1.5rem' }}
              onClick={() => {
                if (bulkAssigner.isLoading) return;
                if (assignedStatus && chapterID && classID && courseID) {
                  bulkAssigner.mutate(
                    {
                      ...apiData,
                      ...{
                        se: assignedSe?.id,
                        tutor: assignedTutor?.id,
                        owner: assignedSeOwner?.id,
                        status: assignedStatus,
                      },
                    },
                    {
                      onSuccess() {
                        closeModal();
                      },
                    }
                  );
                }
              }}
            >
              {bulkAssigner.isLoading ? 'Assigning...' : 'Assign'}{' '}
              <MdSwapCalls color="#fff" fontSize={'22px'} style={{ verticalAlign: 'middle' }} />
            </AppButton>
          </>
          <AppButton variantClass="btn-plane p--tint mx-4  -outline-" onClick={closeModal}>
            Cancel
          </AppButton>
        </div>
      </AppModalBody>
    </AppModal>
  );
}

const initialState = {
  classId: '',
  est: '',
  es: '',
};

export default memo(BulkAssignChapter);
